import { useSearchParams } from 'react-router-dom';
import { Container, Typography, Paper } from '@mui/material';
import StandaloneChatInterface from './StandaloneChatInterface';

const StandalonePage = () => {
  const [searchParams] = useSearchParams();
  
  const assistantId = searchParams.get('assistant');
  const sourceToken = searchParams.get('source');

  if (!assistantId || !sourceToken) {
    return (
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          textAlign: 'center'
        }}
      >
        <Typography variant="h5" color="error" gutterBottom>
          No assistant ID or source provided
        </Typography>
        <Typography variant="body1">
          Please check the URL and try again.
        </Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column', minHeight: '85vh' }}>
        <StandaloneChatInterface 
          assistantId={assistantId} 
          sourceToken={sourceToken}
        />
      </Paper>
    </Container>
  );
};

export default StandalonePage;
